module.exports = __webpack_public_path__ + "img/DK10757711.9330daf4.png";